export default __webpack_public_path__ + "static/media/staking-background-3.bed57652.png";